"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PressSlider = /** @class */ (function () {
    function PressSlider() {
        this.$owl = $('.section-press-partners__carousel');
        this.initCarousel();
    }
    PressSlider.prototype.initCarousel = function () {
        this.$owl.owlCarousel({
            items: 1,
            slideSpeed: 2000,
            nav: true,
            autoplay: true,
            margin: 0,
            dots: true,
            loop: true,
            navText: [
                '<img src="/app/themes/tedee/assets/images/arrow-gray-left.svg" alt="prev arrow" />',
                '<img src="/app/themes/tedee/assets/images/arrow-gray-right.svg" alt="next arrow" />'
            ],
            responsive: {
                768: {
                    items: 2
                },
                1000: {
                    items: 3,
                    margin: 30,
                },
                1440: {
                    items: 4,
                    loop: 0
                }
            }
        });
    };
    return PressSlider;
}());
exports.default = PressSlider;
